'use strict';

exports.__esModule = true;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.addReceipt = addReceipt;
exports.deleteReceipt = deleteReceipt;
exports.addIdentificationPhoto = addIdentificationPhoto;
exports.checkItem = checkItem;
exports.addSignature = addSignature;
exports.markItemAs = markItemAs;
exports.updateItemsBulk = updateItemsBulk;
exports.markAsNext = markAsNext;

var _apiClient = require('../../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  QUIQEE_WAIPOINTS_RECEIPTS: function QUIQEE_WAIPOINTS_RECEIPTS(_ref) {
    var waypointId = _ref.waypointId;
    return '/quiqee/waypoints/' + waypointId + '/receipts';
  },
  QUIQEE_WAIPOINTS_IDENTIFICATION: function QUIQEE_WAIPOINTS_IDENTIFICATION(_ref2) {
    var waypointId = _ref2.waypointId;
    return '/quiqee/waypoints/' + waypointId + '/customer_identification_photos';
  },
  QUIQEE_WAYPOINTS_RECEIPTS_DELETE: function QUIQEE_WAYPOINTS_RECEIPTS_DELETE(_ref3) {
    var waypointId = _ref3.waypointId,
        receiptId = _ref3.receiptId;
    return '/quiqee/waypoints/' + waypointId + '/receipts/' + receiptId;
  },
  QUIQEE_WAIPOINTS_ITEMS: function QUIQEE_WAIPOINTS_ITEMS(_ref4) {
    var waypointId = _ref4.waypointId,
        itemId = _ref4.itemId;
    return '/quiqee/waypoints/' + waypointId + '/items/' + itemId;
  },
  QUIQEE_WAIPOINTS_ITEMS_BULK: function QUIQEE_WAIPOINTS_ITEMS_BULK(waypointId) {
    return '/quiqee/waypoints/' + waypointId + '/items';
  },
  QUIQEE_WAYPOINTS_SIGNATURES: function QUIQEE_WAYPOINTS_SIGNATURES(waypointId) {
    return '/quiqee/waypoints/' + waypointId + '/signatures';
  },
  QUIQEE_WAIPOINT_COMPLETE: function QUIQEE_WAIPOINT_COMPLETE(_ref5) {
    var waypointId = _ref5.waypointId;
    return '/quiqee/waypoints/' + waypointId + '/completions';
  },
  QUIQEE_GET_WAIPOINT: function QUIQEE_GET_WAIPOINT(_ref6) {
    var waypointId = _ref6.waypointId;
    return '/quiqee/waypoints/' + waypointId;
  },
  QUIQEE_WAIPOINTS_ADD_SUBSTITUTION: function QUIQEE_WAIPOINTS_ADD_SUBSTITUTION(_ref7) {
    var waypointId = _ref7.waypointId,
        itemId = _ref7.itemId;
    return '/quiqee/waypoints/' + waypointId + '/items/' + itemId + '/substitutions';
  },
  QUIQEE_WAIPOINTS_DELETE_SUBSTITUTION: function QUIQEE_WAIPOINTS_DELETE_SUBSTITUTION(_ref8) {
    var waypointId = _ref8.waypointId,
        itemId = _ref8.itemId,
        substitutionId = _ref8.substitutionId;
    return '/quiqee/waypoints/' + waypointId + '/items/' + itemId + '/substitutions/' + substitutionId;
  },
  QUIQEE_WAIPOINT_FAILURE: function QUIQEE_WAIPOINT_FAILURE(_ref9) {
    var waypointId = _ref9.waypointId;
    return '/quiqee/waypoints/' + waypointId + '/delivery_failures';
  },
  QUIQEE_WAYPOINT_NEXT: function QUIQEE_WAYPOINT_NEXT(_ref10) {
    var waypointId = _ref10.waypointId;
    return '/courier/waypoints/' + waypointId + '/mark_as_next';
  }

  /**
   * Wrapper for `/quiqee/waypoint` API endpoint
   */

};var waypoints = {
  addReceipt: addReceipt,
  addIdentificationPhoto: addIdentificationPhoto,
  checkItem: checkItem,
  addSignature: addSignature,
  complete: complete,
  getOne: getOne,
  addSubstitution: addSubstitution,
  deleteSubstitution: deleteSubstitution,
  markItemAs: markItemAs,
  deleteReceipt: deleteReceipt,
  updateItemsBulk: updateItemsBulk,
  failure: failure,
  markAsNext: markAsNext
};

exports.default = waypoints;

/**
 * @param {Object} params.waypointId - The id or slug of the waypoint
 * @param {Object} params.file - data uri base64 encoded data:image/jpg;base64,
 * @param {Object} params.amount - The amount in pounds
 * @param {Object} params.transactionType - The receipt's transaction type
 * @returns {promise} with response/errors
 */

function addReceipt(params) {
  var waypointId = params.waypointId;

  return _apiClient2.default.post({ route: API.QUIQEE_WAIPOINTS_RECEIPTS({ waypointId: waypointId }), data: params });
}

/**
 * @param {Object} params.waypointId - The id or slug of the waypoint
 * @param {Object} params.receiptId - The id of the receipt,
 * @returns {promise} with response/errors
 */
function deleteReceipt(params) {
  return _apiClient2.default.remove({ route: API.QUIQEE_WAYPOINTS_RECEIPTS_DELETE(params) });
}

/**
 * @param {Object} params.waypointId - The id or slug of the waypoint
 * @param {Object} params.file - data uri base64 encoded data:image/jpg;base64,
 * @returns {promise} with response/errors
 */
function addIdentificationPhoto(params) {
  var waypointId = params.waypointId;

  return _apiClient2.default.post({ route: API.QUIQEE_WAIPOINTS_IDENTIFICATION({ waypointId: waypointId }), data: params });
}

/**
 * @param {Object} params.waypointId - The id or slug of the waypoint
 * @param {Object} params.itemId - The id of the item
 * @param {Object} params.checked - Whether or not this item has been checked
 * @returns {promise} with response/errors
 */
function checkItem(_ref11) {
  var waypointId = _ref11.waypointId,
      itemId = _ref11.itemId,
      checked = _ref11.checked,
      quantity = _ref11.quantity,
      quantityAvailable = _ref11.quantityAvailable;

  var data = { checked: checked, quantity: quantity, quantityAvailable: quantityAvailable };
  return _apiClient2.default.put({
    route: API.QUIQEE_WAIPOINTS_ITEMS({ waypointId: waypointId, itemId: itemId }),
    data: data
  });
}

/**
 * @param {number} waypointId - The id or slug of the waypoint
 * @param {string} signature - image data base64 encoded
 * @returns {promise} with response/errors
 */
function addSignature(_ref12) {
  var waypointId = _ref12.waypointId,
      signature = _ref12.signature;

  return _apiClient2.default.post({
    route: API.QUIQEE_WAYPOINTS_SIGNATURES(waypointId),
    data: { file: signature }
  });
}
/**
 * @param {Object} params.waypointId - The id or slug of the waypoint
 * @returns {promise} with response/errors
 */
function complete(_ref13) {
  var waypointId = _ref13.waypointId,
      signatureFile = _ref13.signatureFile,
      deliveryLocation = _ref13.deliveryLocation;

  return _apiClient2.default.post({
    route: API.QUIQEE_WAIPOINT_COMPLETE({ waypointId: waypointId }),
    data: { signatureFile: signatureFile, deliveryLocation: deliveryLocation }
  });
}

/**
 * @param {Object} params.waypointId - The id or slug of the waypoint
 * @returns {promise} with response/errors
 */
function getOne(_ref14) {
  var waypointId = _ref14.waypointId;

  return _apiClient2.default.get({ route: API.QUIQEE_GET_WAIPOINT({ waypointId: waypointId }) });
}

/**
 * @param {Object} params.waypointId - The id or slug of the waypoint
 * @param {Object} params.itemId - The id of the item
 * @param {Object} params.ean - EAN of the substitute item
 * @param {Object} params.name - Name of the substitute item
 * @param {Object} params.quantity - How many of these items
 * @param {Object} params.price - Price of the substitute item
 * @returns {promise} with response/errors
 */
function addSubstitution(_ref15) {
  var waypointId = _ref15.waypointId,
      itemId = _ref15.itemId,
      data = (0, _objectWithoutProperties3.default)(_ref15, ['waypointId', 'itemId']);

  return _apiClient2.default.post({
    route: API.QUIQEE_WAIPOINTS_ADD_SUBSTITUTION({ waypointId: waypointId, itemId: itemId }),
    data: data
  });
}

/**
 * @param {Object} params.waypointId - The id or slug of the waypoint
 * @param {Object} params.itemId - The id of the item
 * @param {Object} params.substitutionId - The id of substitution
 * @returns {promise} with response/errors
 */
function deleteSubstitution(_ref16) {
  var waypointId = _ref16.waypointId,
      itemId = _ref16.itemId,
      substitutionId = _ref16.substitutionId;

  return _apiClient2.default.remove({
    route: API.QUIQEE_WAIPOINTS_DELETE_SUBSTITUTION({ waypointId: waypointId, itemId: itemId, substitutionId: substitutionId })
  });
}

/**
 * @param {Object} params.waypointId - The id or slug of the waypoint
 * @param {Object} params.itemId - The id of the item
 * @param {Object} params.state - State of items at waypoint
    pending - item needs picking
    not_available - move to bottom of list during picking
    cancelled - the whole item line was cancelled on customer request
    substituted - item substitution was made
    picked - successful pick
 * @returns {promise} with response/errors
 */
function markItemAs(_ref17) {
  var waypointId = _ref17.waypointId,
      itemId = _ref17.itemId,
      data = (0, _objectWithoutProperties3.default)(_ref17, ['waypointId', 'itemId']);

  return _apiClient2.default.put({
    route: API.QUIQEE_WAIPOINTS_ITEMS({ waypointId: waypointId, itemId: itemId }),
    data: data
  });
}

/**
 * @param {Object} params.waypointId - Id of the waypoint
 * @param {Object} params.items - Items array [{ id: 1, checked: false, ... }]
 * @returns {promise} with response/errors
 */
function updateItemsBulk(_ref18) {
  var waypointId = _ref18.waypointId,
      items = _ref18.items;

  var data = { waypointId: waypointId, items: items };
  return _apiClient2.default.put({
    route: API.QUIQEE_WAIPOINTS_ITEMS_BULK(waypointId),
    data: data
  });
}

/**
 * @param {Object} params.waypointId - The id or slug of the waypoint
 * @param {Object} params.deliveryFailureReasonId - The id of the failure reason
 * @returns {promise} with response/errors
 */
function failure(_ref19) {
  var waypointId = _ref19.waypointId,
      deliveryFailureReasonId = _ref19.deliveryFailureReasonId;

  var data = { deliveryFailureReasonId: deliveryFailureReasonId };
  return _apiClient2.default.post({ route: API.QUIQEE_WAIPOINT_FAILURE({ waypointId: waypointId }), data: data });
}

/**
 * @param {Object} params.orderId - The id of the order
 * @returns {promise} with response/errors
 */
function markAsNext(_ref20) {
  var waypointId = _ref20.waypointId;

  return _apiClient2.default.post({ route: API.QUIQEE_WAYPOINT_NEXT({ waypointId: waypointId }) });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/quiqee/waypoints/waypoints.js
// module id = 1178
// module chunks = 0